import { axiosFunction } from "../components/commonFunctions";
import { v2ReactURL } from "./constant";

export const validateMobileNumber = async (
  mobileNumber : string,
  contactType : string,
  contactId : Number
) => {
  try {
    const res = await axiosFunction(
      `${v2ReactURL}/contact/${contactType}/checkmobilenumber?contactId=${contactId}&mobileNumber=${mobileNumber}`,
      "POST",
      null
    );
    return res;
  } catch (err) {
    return false;
  }
};
